import { all, takeEvery, takeLatest } from 'redux-saga/effects';
import {
  fetchThings,
  fetchThing,
  fetchZonesByUser,
  fetchParksByUserCustomer,
  fetchZonesByUserCustomer,
} from './ducks/park/sagas';
import { fetchHistoricData } from './ducks/historic/sagas';
import { setUser, setInitialize } from './ducks/user/sagas';
import { addNotification } from './ducks/notifications/sagas';
import { getThingVariables, conectaThings } from './ducks/iot/iot-saga';
import { conectaAplicacoes } from './ducks/first-level/first-level-saga';
import {
  conectaAplicacoesSegundoNivel,
  buscaZonasCliente,
} from './ducks/second-level/second-level-saga';
import { fetchQuantidade } from './ducks/events/sagas';
import { conectaThing } from './ducks/operational/sagas';

export default function* root() {
  yield all([
    takeLatest('PARQUE/FETCH_THINGS', fetchThings),
    takeLatest('PARQUE/FETCH_THING', fetchThing),
    takeLatest('PARQUE/FETCH_ZONES', fetchZonesByUser),
    takeLatest('PARQUE/FETCH_ZONES_CUSTOMER', fetchZonesByUserCustomer),
    takeLatest('PARQUE/FETCH_PARKS_CUSTOMER', fetchParksByUserCustomer),
    // takeEvery (NAO takeLatest) porque o operador pode adicionar 2-3
    // variaveis em sequencia rapida no modal avancado: cada dispatch e
    // pra uma variavel diferente (variable+period unicos) e queremos que
    // TODAS sejam buscadas. Com takeLatest, so a ultima sobrevivia — as
    // anteriores ficavam loading eterno ate o operador clicar de novo.
    // Dedupe ja existe no caller (cache check em compareHistoric).
    takeEvery('HISTORIC/FETCH_VARIABLE_HISTORIC', fetchHistoricData),
    takeLatest('USER/SAGA_SET_USER', setUser),
    takeLatest('USER/SET_INITIALIZE', setInitialize),
    takeLatest('NOTIFICATION/SAGA_SET_NOTIFICATION', addNotification),
    takeLatest('IOT/SAGA_GET_THING_VARIABLES', getThingVariables),
    takeLatest('PRIMEIRO/ABRE_CONEXAO_THINGS', conectaAplicacoes),
    takeLatest('SEGUNDO/ABRE_CONEXAO_THINGS', conectaAplicacoesSegundoNivel),
    takeLatest('SEGUNDO/BUSCA_ZONAS_CUSTOMER', buscaZonasCliente),
    takeLatest('EVENTOS/SAGA_BUSCA_QUANTIDADE', fetchQuantidade),
    takeLatest('OPERACIONAL/ABRE_CONEXAO_THING', conectaThing),
    takeLatest('IOT/ABRE_CONEXAO_THING', conectaThings),
  ]);
}
